import { render, staticRenderFns } from "./Audits.vue?vue&type=template&id=6511c7af&"
import script from "./Audits.vue?vue&type=script&lang=js&"
export * from "./Audits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports